import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {GreenButton, ButtonsGroup} from '../../components/Button/ButtonMix';
import Description from '../../components/Heading/Description';
import {BlueContainer, DefaultContainer} from '../../components/Container/ContainerMix';

const Wrapper = styled.div`
  text-align: center;
`;

const SectionTitle = styled.h1`
  color: #ffffff;
  font-size: 1.15rem !important;
  font-weight: bold !important;
  letter-spacing: 1px !important;
  line-height: 19px;
  text-align: left;
`;

const Total = styled.p`
  color: #FFFFFF;
  font-size: 72px;
  line-height: 85px;
  text-shadow: 0px 3px rgba(0,0,0,0.1) !important;
  text-align: left;
  margin-top: 2rem;
`;

const ActivitySection = ({heading, isLoading, subheading, description, onNext, nextLabel, children}) => (
  <Wrapper className="Wrapper">
    <BlueContainer>
      <SectionTitle>{subheading}</SectionTitle>
      <Total>{heading}</Total>
    </BlueContainer>
    <Description>{description}</Description>
    <DefaultContainer>
      {children}
      <ButtonsGroup>
        <GreenButton disabled={isLoading} onClick={onNext}>
          {isLoading ? <i aria-hidden="true" className="spinner loading icon"/> : nextLabel}
        </GreenButton>
      </ButtonsGroup>
    </DefaultContainer>
  </Wrapper>
);
ActivitySection.propTypes = {
  heading: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  subheading: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  onNext: PropTypes.func.isRequired,
  nextLabel: PropTypes.string.isRequired,
  children: PropTypes.any
};

export default ActivitySection;



// WEBPACK FOOTER //
// ./src/pages/Activities/ActivitySection.js